// TODO: simplify when module namespaced
export const PRODUCT_MODIFICATION_PROCESS_CLEAR_STATE = "clearProductModificationProcessState";

// TODO: simplify when module namespaced
export const PRODUCT_MODIFICATION_PROCESS_CLEAR_ACTION = "clearProductModificationProcessAction";

export const ProductModificationProcessStoreActions = {
	CLEAR: `${PRODUCT_MODIFICATION_PROCESS_CLEAR_ACTION}`
} as const;
